import { Box, Grid, TextField, Button, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Route } from "../../utils/config";
import Note from "../Note";
export default function NoteContainer({ projectId }) {
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const handleInputChange = (value) => {
    setNewNote(value);
  };

  const getProjectNotes = useCallback(() => {
    setIsLoading(true);
    let store = JSON.parse(localStorage.getItem("login"));
    axios
      .get(`${Route}/Projects/GetProjectNotes`, {
        params: {
          projectId: projectId,
        },
        headers: { Authorization: `Bearer ${store.token}` },
      })
      .then((res) => {
        setNotes(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        throw err;
      });
  }, [projectId]);

  const submitNewNote = (note) => {
    let store = JSON.parse(localStorage.getItem("login"));
    const body = {
      id: -1,
      projectId: projectId,
      note: note,
    };
    axios
      .post(`${Route}/Projects/SaveProjectNote`, JSON.stringify(body), {
        headers: {
          Authorization: `Bearer ${store.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setNotes([...notes, res.data]);
        setNewNote("");
      })
      .catch((err) => {
        throw err;
      });
  };

  const editNote = (note, noteId) => {
    let store = JSON.parse(localStorage.getItem("login"));
    const body = {
      id: noteId,
      projectId: projectId,
      note: note,
    };
    axios
      .post(`${Route}/Projects/SaveProjectNote`, JSON.stringify(body), {
        headers: {
          Authorization: `Bearer ${store.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setNotes(notes.map((note) => (note.id === noteId ? res.data : note)));
      })
      .catch((err) => {
        throw err;
      });
  };

  const handleDeleteNote = (noteId) => {
    let store = JSON.parse(localStorage.getItem("login"));
    axios
      .post(
        `${Route}/Projects/DeleteProjectNote`,
        {},
        {
          params: {
            noteId: noteId,
          },
          headers: { Authorization: `Bearer ${store.token}` },
        }
      )
      .then((res) => {
        setNotes(
          notes.filter((note) => {
            return note.id !== noteId;
          })
        );
      })
      .catch((err) => {
        throw err;
      });
  };

  useEffect(() => {
    getProjectNotes();
  }, [getProjectNotes]);

  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            submitNewNote(newNote);
          }}
        >
          <TextField
            fullWidth
            label="New Note"
            value={newNote}
            onChange={(e) => handleInputChange(e.target.value)}
            sx={{ marginBottom: 2 }}
          ></TextField>
          <Button variant="contained" type="submit" disabled={newNote === ""}>
            Add Note
          </Button>
        </Box>
      </Grid>
      {!isLoading ? (
        notes.map((note, i) => {
          return (
            <Grid item xs={12} key={i}>
              <Note
                id={note.id}
                noteId={note.id}
                projectId={projectId}
                note={note.note}
                date={note.modified}
                deleteNote={handleDeleteNote}
                editNote={editNote}
              ></Note>
            </Grid>
          );
        })
      ) : (
        <Grid container item justifyContent="center" xs={12} height="100%">
          <CircularProgress></CircularProgress>
        </Grid>
      )}
    </Grid>
  );
}
